export class NumberUtils {
    public static formatAsPercentage(value: number, minFraction: number) : string {
        return value != null
            ? (value/100).toLocaleString(undefined, {style: 'percent', minimumFractionDigits: minFraction})
            : '';
    }
}